<script setup>
import SummaryBlockParams from './Blocks/SummaryBlockParams.vue';
import SummaryBlockServices from './Blocks/SummaryBlockServices.vue';
import SummaryBlockTariff from './Blocks/SummaryBlockTariff.vue';
import SummaryButtons from './SummaryButtons.vue';
import SummaryCalculation from './Calculation/SummaryCalculation.vue';
import SummaryTitle from './SummaryTitle.vue';
import useCalculatorStore from '../../store/calculator.js';

const calculator = useCalculatorStore();
</script>

<template>
  <div class="cloud-calculator__summary">
    <SummaryTitle/>
    <SummaryBlockTariff/>
    <SummaryBlockParams/>
    <SummaryBlockServices/>
    <SummaryCalculation v-if="calculator.total"/>
    <SummaryButtons/>
  </div>
</template>
